import styled from 'styled-components'

export const ThemedSvg = styled.svg.attrs(({ fill, theme }) => ({
  fill: fill ?? 'currentColor'
}))``
